import type { LegacyRoomLayoutElectrical } from "building-types/electrical/electricalLegacyRoomLayoutTypes";

export function roomLayoutElectricalMergeInto(a: LegacyRoomLayoutElectrical, b: LegacyRoomLayoutElectrical) {
  a.embeddedGroups.push(...b.embeddedGroups);
}
